import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FacebookPostComponent } from './facebook-post/facebook-post.component';
import { CategoriesComponent } from './categories/categories.component';
import { InstagramPostComponent } from './instagram-post/instagram-post.component';
import { InstagramStoryComponent } from './instagram-story/instagram-story.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { AboutComponent } from './about/about.component';
import { ContactComponent } from './contact/contact.component';
import { InstagramRealComponent } from './instagram-real/instagram-real.component';
import { AppUiComponent } from './app-ui/app-ui.component';
import { WebsiteUiComponent } from './website-ui/website-ui.component';
import { FacebookCoverComponent } from './facebook-cover/facebook-cover.component';
import { FacebookAdComponent } from './facebook-ad/facebook-ad.component';
import { MockupPreviewComponent } from './mockup-preview/mockup-preview.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatDialogModule} from '@angular/material/dialog';

@NgModule({
  declarations: [
    AppComponent,
    FacebookPostComponent,
    CategoriesComponent,
    InstagramPostComponent,
    InstagramStoryComponent,
    PageNotFoundComponent,
    AboutComponent,
    ContactComponent,
    InstagramRealComponent,
    AppUiComponent,
    WebsiteUiComponent,
    FacebookCoverComponent,
    FacebookAdComponent,
    MockupPreviewComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatDialogModule
  ],
  entryComponents: [MockupPreviewComponent],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
